import { FunctionComponent, useEffect, useState } from "react";
import {
  Backdrop,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import { useDeleteFlight } from "../../hooks/useFlight";

type Props = { id: string; onClose: () => void };

export const DeleteFlightModal: FunctionComponent<Props> = ({ id, onClose }) => {
  const deleteMutation = useDeleteFlight();
  const [confirmation, setConfirmation] = useState("");

  useEffect(() => {
    setConfirmation("");
  }, [id]);

  const handleDelete = () => {
    if (confirmation !== id) {
      return;
    }
    deleteMutation.mutate(id);
    onClose();
  };

  return (
    <>
      <Backdrop sx={{ zIndex: (theme) => theme.zIndex.modal + 1 }} open={deleteMutation.isLoading}>
        <CircularProgress />
      </Backdrop>
      <Dialog open={Boolean(id)} onClose={onClose} fullWidth maxWidth="xs" aria-labelledby="delete-flight-title">
        <DialogTitle id="delete-flight-title">Delete flight…</DialogTitle>
        <DialogContent>
          <Stack spacing={2} sx={{ pt: 1 }}>
            <Typography variant="body2" color="text.secondary">
              This permanently deletes flight {id}. Type the exact flight ID to confirm.
            </Typography>
            <TextField
              autoFocus
              label="Flight ID"
              value={confirmation}
              onChange={(event) => setConfirmation(event.target.value)}
              helperText={`Enter ${id}`}
              fullWidth
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Cancel</Button>
          <Button color="error" variant="contained" onClick={handleDelete} disabled={confirmation !== id || deleteMutation.isLoading}>
            Delete flight
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
